// #636: Welche Anhänge der Betrachter selbst zeigt. Der Server liefert alles
// außer Bildern als application/octet-stream (#281, kein fremdes Script auf
// dem Anwendungs-Origin). Der Client typisiert den Blob deshalb selbst, aber
// nur für die beiden Arten, die er sicher darstellen kann: Bilder (im <img>
// läuft kein Script, auch nicht bei SVG) und PDF (gerendert von pdf.js auf
// Canvas, ohne eval). Alles andere bleibt Download.

const BILD_ENDUNGEN = { jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', gif: 'image/gif', webp: 'image/webp', bmp: 'image/bmp' };

function endung(name) {
  const m = /\.([a-z0-9]+)$/i.exec(String(name || ''));
  return m ? m[1].toLowerCase() : '';
}

/** 'bild' | 'pdf' | null */
export function anhangArt(anhang) {
  const typ = String(anhang?.typ || anhang?.contentType || '').toLowerCase().split(';')[0].trim();
  const e = endung(anhang?.name || anhang?.originalName);
  if (typ === 'application/pdf' || e === 'pdf') return 'pdf';
  if (anhang?.isImage === true) return 'bild';
  if (/^image\/(jpeg|png|gif|webp|bmp)$/.test(typ) || BILD_ENDUNGEN[e]) return 'bild';
  return null;
}

/** MIME-Typ, mit dem der Blob angezeigt wird (nur für bild/pdf). */
export function anzeigeTyp(anhang) {
  const art = anhangArt(anhang);
  if (art === 'pdf') return 'application/pdf';
  if (art !== 'bild') return null;
  const typ = String(anhang?.typ || anhang?.contentType || '').toLowerCase().split(';')[0].trim();
  if (/^image\/(jpeg|png|gif|webp|bmp)$/.test(typ)) return typ;
  return BILD_ENDUNGEN[endung(anhang?.name || anhang?.originalName)] || 'image/jpeg';
}

/** Download-Adresse eines Ticket-Anhangs (Content-Disposition liefert den Namen). */
export function ticketAnhangUrl(ticketId, anhangId) {
  return `/api/tickets/${encodeURIComponent(ticketId)}/attachments/${encodeURIComponent(anhangId)}/content`;
}
